import React, { useEffect, useState, useMemo } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import FormWrapper from "../../FormWrapper";
import {
  getClientActionsDetailById,
  getClientActionsListItems,
} from "../../../../redux/SystemManager/clientActions";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import { Toaster } from "@fluentui/react-components";
import { FormLoader } from "../../../../components/Loader/FormLoader";
import { TableListLoader } from "../../../../components/Loader/TableListLoader";
import ListWrapper from "../../ListWrapper";
import { configFm } from "../../../../types";

const FORM_CONTEXT = "MASTER_SETTINGS_CLIENT_ACTIONS";
const API_BASE_PATH = "/system-manager/customisations/client-action";

function ClientActionsDetailPage() {
  const { itemId, action } = useParams();
  const location = useLocation();
  const { showToast, toasterId } = useToastMessage();
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const { activeItem, listItems, loading, activeItemloading } = useSelector(
    (state: RootState) => state.clientActions
  );
  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const [configForm, setConfigForm] = useState<configFm>();
  const [currentRecord, setCurrentRecord] = useState(1);

  useEffect(() => {
    dispatch(getClientActionsListItems());
  }, [dispatch]);

  useEffect(() => {
    if (listItems.length > 0 && itemId) {
      dispatch(getClientActionsDetailById(itemId));
    }
  }, [listItems, itemId, dispatch]);

  console.log(listItems, "listItems");
  console.log(activeItem, "activeItem");

  useEffect(() => {
    if (
      formSettingsObj?.systemAdmin &&
      formSettingsObj.systemAdmin.formConfig !== undefined
    ) {
      let configObj = formSettingsObj.systemAdmin.formConfig.find(
        (item: any) => item.context === FORM_CONTEXT
      );
      if (configObj) {
        setConfigForm(configObj);
      }
    }
  }, [formSettingsObj]);

  // FIXED: Improved fallback selection after reload (e.g., post-delete)
  // Always prioritize first item (index 0), fetch its details, navigate, and reset currentRecord to 1
  useEffect(() => {
    if (listItems.length > 0 && !activeItem) {
      // !activeItem checks for empty object or null
      const firstItem = listItems[0];
      if (firstItem) {
        // Fetch details for first item
        dispatch(getClientActionsDetailById(firstItem.id));
        // Navigate to it (triggers detail view)
        navigate(`${API_BASE_PATH}/${firstItem.id}/view`);
        // Reset record counter to 1 (1-based)
        setCurrentRecord(1);
      }
    }
  }, [listItems, activeItem]); // Triggers on list reload or activeItem clear

  const loadData = async (
    dispatch: AppDispatch,
    id?: string
  ): Promise<void> => {
    await dispatch(getClientActionsListItems());
    // FIXED: If no id (e.g., after delete), auto-select and fetch first item
    if (!id && listItems.length > 0) {
      // Use post-fetch listItems (async, so check after await)
      const firstItem = listItems[0];
      if (firstItem) {
        await dispatch(getClientActionsDetailById(firstItem.id));
        setCurrentRecord(1); // Reset counter
      }
    } else if (id) {
      await dispatch(getClientActionsDetailById(id));
    }
  };

  const hasListItems = useMemo(() => listItems.length > 0, [listItems]);

  return (
    <>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <div className="admin_container_flex">
        {action &&
          (activeItemloading ? (
            <FormLoader />
          ) : (
            <FormWrapper
              dataList={listItems}
              context={FORM_CONTEXT}
              reloadData={loadData}
              selectedRowItem={activeItem}
              config={configForm}
              action={action || "view"}
              apiPath={API_BASE_PATH}
              notify={showToast}
              activeRow={currentRecord}
            />
          ))}

        {loading ? (
          <TableListLoader rows={8} columns={6} />
        ) : (
          hasListItems &&
          action &&
          listItems.length > 0 && (
            <ListWrapper
              data={listItems}
              context={FORM_CONTEXT}
              selectedRowItem={activeItem}
              onRowAction={(action, row) =>
                navigate(`${API_BASE_PATH}/${row?.id}/${action || "view"}`)
              }
              currentRecord={(index) => setCurrentRecord(index)} // FIXED: Ensure 1-based (if not already)
            />
          )
        )}
      </div>
    </>
  );
}

export default ClientActionsDetailPage;
